import { array, bool, number, object, string } from 'yup';
import moment from 'moment';

import { ContentInput } from 'api';
import { isValidPost } from './helpers';

const MIN_GROUPS = 1;

const PostSchema = () => {
  return object()
    .shape({
      group_ids: array()
        .compact()
        .min(MIN_GROUPS),
      content_object: object().shape({
        body: string(),
        photos: array().nullable(true),
        url: string().nullable(true),
      }),
      is_shareable: bool().required(),
      is_important: bool().required(),
      is_pinned: bool().required(),
      pinned_end_at: number().when('is_pinned', {
        is: value => !!value,
        then: number().test('is-future', 'REQUIRED MESSAGE', function(value: number) {
          const { content_id } = this.parent;
          if (content_id) {
            return true;
          }

          return moment.unix(value).isAfter();
        }),
        otherwise: number().nullable(true),
      }),
      url_param_values: array()
        .of(
          object().shape({
            key: string().required(),
            value: string().required(),
          }),
        )
        .nullable(),
    })
    .test('is-valid', 'REQUIRED MESSAGE', (values: ContentInput) => {
      return isValidPost(values);
    });
};

export { PostSchema };
